import type { EggerDecor } from "../domain/eggerDecors";

/** Visual sample sizes, independent of manufacturing sheet dimensions.
 * Source swatches are 1024 × 576, with wood grain along the image's Y axis.
 * Keep that aspect ratio instead of stretching a close-up into a tall sheet.
 */
export function decorTextureSize(decor: Pick<EggerDecor, "code" | "group">) {
  let width = { wood: 1.05, stone: 1.8, metal: 0.9, fabric: 0.45, plain: 1 }[decor.group];
  // Halifax swatches have especially large pores and split-board details.
  if (/^H(?:1176|1180|1181|3176)\b/.test(decor.code)) width = 0.78;
  return { width, height: width * 576 / 1024 };
}
